import { AgentChat } from "@/components/chat/AgentChat";

export default function CVTool() {
  return <AgentChat agent="cv" />;
}
